module.exports = __webpack_public_path__ + "static/images/containers/WGCWXShop/containers/WGCWXRewardsTank/components/Footer/images/footer_bg.14274820.png";


//////////////////
// WEBPACK FOOTER
// ./containers/WGCWXShop/containers/WGCWXRewardsTank/components/Footer/images/footer_bg.png
// module id = 1043
// module chunks = 16